<template>
  <div style="width: 1000px; margin: auto; margin-top: 100px;">
    <v-container fluid>
      <v-card>
        <v-card-text>
          <v-progress-circular indeterminate></v-progress-circular>Confirming your e-mail...
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "axios";

export default {
  methods: {
    ...mapMutations(["ALERT_SUCCESS", "ALERT_ERROR"])
  },
  async created() {
    document.title = "Confirm E-mail - Landly Console";
    const token = this.$route.query.token;
    const email = this.$route.query.email;
    await axios.post("/Console/ConfirmEmail", {
      token,
      email
    });
    this.ALERT_SUCCESS("E-mail confirmed");
    this.$router.push("/projects");
  }
};
</script>